import type { Attribute, ServiceObject } from '../../../types';

export function transformServices(services: Record<ServiceObject['internal_name'], ServiceObject>) {
  // The IEV service is patched for a specific reason outlined in the function below.
  const mappedEntries = Object.entries(services).map(([internalName, service]) => {
    if (internalName === 'IdentityElementVelocity') {
      const patchedIEVService = patchIEVWithWorkflowScopeAttrComponent(service);
      return [internalName, patchedIEVService];
    }
    return [internalName, service];
  });

  return Object.fromEntries(mappedEntries);
}

/**
 * The IEV Service is patched to overwrite its only attribute description and selector to show the
 * `workflow_scope` attribute component in the MLA editor experience and the rest of the application.
 * This is needed because an incident prompted other engineers to manually overwrite these database
 * fields.
 * More details here:
 *  - https://team-alloy.atlassian.net/browse/BUILD-2675
 *  - incident: https://firstmilegroup.slack.com/archives/C07990PNRNX
 *
 * These changes will be reverted back once the client updates their implementation and the migration
 * can be applied again. That revert is tracked in BUILD-2731
 */
export function patchIEVWithWorkflowScopeAttrComponent(service: ServiceObject): ServiceObject {
  const patchedAttributeDescription = 'Count of other {entities} that have used the same {pii_element} as this evaluation in the past {time_frame}{interval} within the scope of {workflow_scope} (inclusive)';
  const patchedAttributeSelector = 'data.decision.{entities}.{pii_element}.{time_frame}_{interval}.{workflow_scope}';

  const singleAttributeKey = Number(Object.keys(service.attributes)[0]);
  const singleIEVAttribute = service.attributes[singleAttributeKey];

  const patchedAttribute: Attribute = {
    ...singleIEVAttribute,
    selector: patchedAttributeSelector,
    description: patchedAttributeDescription,
  };

  return {
    ...service,
    attributes: {
      ...service.attributes,
      [singleAttributeKey]: patchedAttribute,
    },
  };
}
